/**
 * Integração com Shopify
 * Script para integração do bloqueio de país com Shopify
 */

// Aguardar o Shopify carregar
if (typeof Shopify !== 'undefined' || document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopifyCountryBlocker);
} else {
    initShopifyCountryBlocker();
}

function initShopifyCountryBlocker() {
    // Verificar se já foi inicializado
    if (window.ShopifyCountryBlockerInitialized) {
        return;
    }
    
    window.ShopifyCountryBlockerInitialized = true;
    
    // Configurações específicas do Shopify
    var ShopifyConfig = {
        // Verificar se é admin
        isAdmin: function() {
            return window.location.pathname.indexOf('/admin') !== -1 || 
                   window.location.pathname.indexOf('/checkout') !== -1 ||
                   document.body.classList.contains('admin') ||
                   document.documentElement.classList.contains('admin');
        },
        
        // Verificar se é checkout
        isCheckout: function() {
            return window.location.pathname.indexOf('/checkout') !== -1 ||
                   window.location.pathname.indexOf('/cart') !== -1 ||
                   document.body.classList.contains('checkout') ||
                   document.documentElement.classList.contains('checkout');
        },
        
        // Verificar se é página de produto
        isProduct: function() {
            return window.location.pathname.indexOf('/products/') !== -1 ||
                   document.body.classList.contains('product') ||
                   document.documentElement.classList.contains('product');
        },
        
        // Verificar se é página de coleção
        isCollection: function() {
            return window.location.pathname.indexOf('/collections/') !== -1 ||
                   document.body.classList.contains('collection') ||
                   document.documentElement.classList.contains('collection');
        },
        
        // Obter informações do produto atual
        getCurrentProduct: function() {
            if (typeof window.meta !== 'undefined' && window.meta.product) {
                return window.meta.product;
            }
            return null;
        },
        
        // Obter informações da coleção atual
        getCurrentCollection: function() {
            if (typeof window.meta !== 'undefined' && window.meta.collection) {
                return window.meta.collection;
            }
            return null;
        },
        
        // Verificar se deve bloquear baseado no produto
        shouldBlockProduct: function(product) {
            if (!product) return false;
            
            // Verificar tags do produto
            if (product.tags && product.tags.indexOf('block-brazil') !== -1) {
                return true;
            }
            
            // Verificar tipo do produto
            if (product.type && product.type.toLowerCase().indexOf('restricted') !== -1) {
                return true;
            }
            
            return false;
        },
        
        // Verificar se deve bloquear baseado na coleção
        shouldBlockCollection: function(collection) {
            if (!collection) return false;
            
            // Verificar tags da coleção
            if (collection.tags && collection.tags.indexOf('block-brazil') !== -1) {
                return true;
            }
            
            return false;
        }
    };
    
    // Função principal de verificação
    function checkAndBlock() {
        // Não bloquear admin ou checkout
        if (ShopifyConfig.isAdmin() || ShopifyConfig.isCheckout()) {
            return;
        }
        
        // Verificar se já foi verificado nesta sessão
        if (sessionStorage.getItem('country_blocker_checked') === 'true') {
            return;
        }
        
        // Verificar produto específico
        var currentProduct = ShopifyConfig.getCurrentProduct();
        if (currentProduct && !ShopifyConfig.shouldBlockProduct(currentProduct)) {
            return;
        }
        
        // Verificar coleção específica
        var currentCollection = ShopifyConfig.getCurrentCollection();
        if (currentCollection && !ShopifyConfig.shouldBlockCollection(currentCollection)) {
            return;
        }
        
        // Executar verificação de país
        if (typeof ZACB !== 'undefined' && typeof ZACB.za_c_b === 'function') {
            ZACB.za_c_b();
        } else {
            // Carregar script de bloqueio se não estiver disponível
            loadCountryBlockerScript();
        }
        
        // Marcar como verificado
        sessionStorage.setItem('country_blocker_checked', 'true');
    }
    
    // Carregar script de bloqueio de país
    function loadCountryBlockerScript() {
        var script = document.createElement('script');
        script.src = '/assets/country-blocker.js';
        script.onload = function() {
            if (typeof ZACB !== 'undefined' && typeof ZACB.za_c_b === 'function') {
                ZACB.za_c_b();
            }
        };
        document.head.appendChild(script);
    }
    
    // Carregar scripts necessários
    function loadRequiredScripts() {
        var scripts = [
            '/assets/country-config.js',
            '/assets/proxy-checker.js'
        ];
        
        var loaded = 0;
        scripts.forEach(function(src) {
            var script = document.createElement('script');
            script.src = src;
            script.onload = function() {
                loaded++;
                if (loaded === scripts.length) {
                    checkAndBlock();
                }
            };
            script.onerror = function() {
                loaded++;
                if (loaded === scripts.length) {
                    checkAndBlock();
                }
            };
            document.head.appendChild(script);
        });
    }
    
    // Inicializar
    loadRequiredScripts();
    
    // Verificar novamente quando a página mudar (para SPAs)
    var lastUrl = location.href;
    new MutationObserver(function() {
        var url = location.href;
        if (url !== lastUrl) {
            lastUrl = url;
            sessionStorage.removeItem('country_blocker_checked');
            setTimeout(checkAndBlock, 100);
        }
    }).observe(document, { subtree: true, childList: true });
    
    // Verificar quando o usuário voltar para a página
    window.addEventListener('focus', function() {
        if (sessionStorage.getItem('country_blocker_checked') !== 'true') {
            checkAndBlock();
        }
    });
    
    // Verificar quando a página for exibida
    document.addEventListener('visibilitychange', function() {
        if (!document.hidden && sessionStorage.getItem('country_blocker_checked') !== 'true') {
            checkAndBlock();
        }
    });
}

// Função para bypass manual (para testes)
window.bypassCountryBlocker = function() {
    sessionStorage.setItem('country_blocker_checked', 'true');
    if (typeof ZACB !== 'undefined') {
        ZACB.createCookie('admin_login_success', 'true', 1);
    }
    location.reload();
};

// Função para reativar o bloqueio (para testes)
window.enableCountryBlocker = function() {
    sessionStorage.removeItem('country_blocker_checked');
    if (typeof ZACB !== 'undefined') {
        ZACB.eraseCookie('admin_login_success');
    }
    location.reload();
};

// Exportar para uso global
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        initShopifyCountryBlocker: initShopifyCountryBlocker,
        ShopifyConfig: ShopifyConfig
    };
} else if (typeof window !== 'undefined') {
    window.ShopifyCountryBlocker = {
        init: initShopifyCountryBlocker,
        bypass: window.bypassCountryBlocker,
        enable: window.enableCountryBlocker
    };
}

